import * as React from 'react';
import getInteractionSeverity from './interactionsSeverityFunctions';
import Translate from '../../../common/functions/translate';
import { Accordion, AccordionTab } from 'primereact/accordion';

const drugInteractionsLegend = (props) => {
  const legendElement =


    <div style={{ marginTop: "10px" }}>
      <Accordion>
        <AccordionTab header={Translate('Legend')}>
          <div style={{ fontSize: '0.9em' }}>
            <h4>{Translate('DrugInteractionClassification')}</h4>
            <table className="table">
              <tbody>
                <tr>
                  <td>{Translate('DrugInteractionClassificationDescription')}</td>
                </tr>
                <tr>
                  <td>
                    <div style={{ fontWeight: 600, color: "#d32f2f" }}>{getInteractionSeverity('icon', 1)}&nbsp;{Translate('Major')}</div>
                    {Translate('DrugInteractionClassificationMajor')}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div style={{ fontWeight: 600, color: "#f57c00" }}>{getInteractionSeverity('icon', 2)}&nbsp;{Translate('Moderate')}</div>
                    {Translate('DrugInteractionClassificationModerate')}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div style={{ fontWeight: 600, color: "#fbc02d" }}>{getInteractionSeverity('icon', 3)}&nbsp;{Translate('Minor')}</div>
                    {Translate('DrugInteractionClassificationMinor')}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div style={{ fontWeight: 600, color: "#b3b3b3" }}>{getInteractionSeverity('icon', 4)}&nbsp;{Translate('Unknown')}</div>
                    {Translate('DrugInteractionClassificationUnknown')}
                  </td>
                </tr>
              </tbody>
            </table>
            <p>{Translate('DrugInteractionClassificationDoNotStop')}</p>
          </div>
        </AccordionTab>
      </Accordion>
    </div>;

  return (
    <div>
      {legendElement}
    </div>
  )
}

export default drugInteractionsLegend;